<!--
    @name       AppDialog
    @desc       通用弹窗组件
    @props
        dialog: {
            type        类型[alert、confirm、tips]
            message     信息
            callback    回调函数
        }
-->
<template>
  <div>
    <div class="layer-wraper" v-show="type === 'alert' || type === 'confirm'" @click="cancelClick()">
      <div class="layer-content" v-show="type ==='alert' ||type === 'confirm'" @click.stop>
        <div class="message" v-text="message"></div>
        <div class="footer">
          <p class="button" @click.stop="cancelClick()" v-show="type === 'confirm'">取消</p>
          <p class="button" @click.stop="okClick()">确定</p>
        </div>
      </div>
    </div>
    <div class="tips" v-show="type ==='tips'" v-text="message"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AppDialog',
  data() {
    return {
      time: null // toast 自动隐藏定时器
    }
  },
  methods: {
    ...mapActions('system', ['clearDialog']),
    okClick() {
      this.callback && this.callback(true)
      this.clearDialog()
    },
    cancelClick() {
      this.callback && this.callback(false)
      this.clearDialog()
    }
  },
  watch: {
    type() {
      if (this.type === 'tips') {
        if (this.time) {
          clearTimeout(this.time)
        }
        this.time = setInterval(() => {
          this.callback && this.callback()
          this.clearDialog()
        }, 2500)
      } else {
        clearTimeout(this.time);
        this.time = null
      }
    }
  },
  computed: {
    ...mapState({
      type: state => state.system.type,
      message: state => state.system.message,
      callback: state => state.system.callback
    })
  }
}
</script>

<style lang="scss" scoped>
.layer-wraper {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.3);
}

@keyframes show {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@keyframes showtip {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.tips {
  z-index: 9999;
  top: 50%;
  left: 50%;
  color: #fff;
  padding: 30px;
  font-size: 32px;
  position: fixed;
  border-radius: 6px;
  animation: showtip 0.5s;
  transform: translate(-50%, -50%);
  background: rgba($color: #000000, $alpha: 0.8);
  white-space:nowrap;
}
.layer-content {
  width: 620px;
  height: 320px;
  display: flex;
  padding-top: 50px;
  background: #fff;
  border-radius: 6px;
  animation: show 0.3s;
  box-sizing: border-box;
  flex-direction: column;
  font-family: 'PingFang SC';
  .message {
    flex: 1;
    padding: 30px 40px 0;
    font-size: 32px;
    color: #666666;
    text-align: center;
  }
  .footer {
    width: 100%;
    height: 110px;
    display: flex;
    line-height: 110px;
    position: relative;
    box-sizing: border-box;
    border-top: 1px solid #eaeaea;
    .button {
      width: 100%;
      font-size: 34px;
      color: #666666;
      /*font-weight: bold;*/
      text-align: center;
      letter-spacing: 3px;
      &:last-child {
        color: #16bdf9;
        border-left: 1px solid #eaeaea;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppDialog/AppDialog.vue